import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";

function RoomSeaterPage() {
  const { seater } = useParams(); // e.g., "1-Seater"
  const { search } = useLocation();
  const [room, setRoom] = useState(null);
  const navigate = useNavigate();
  const type = new URLSearchParams(search).get("type");
  
  useEffect(() => {
    const roomsRef = ref(db, "rooms");
    const unsubscribe = onValue(roomsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const matchedRoom = Object.values(data).find(r => r.name === seater && r.type === type);
        if (matchedRoom) {
          const imagesArray = [];
          if (matchedRoom.images) {
            Object.values(matchedRoom.images).forEach(img => {
              if (!img) return;
              imagesArray.push(typeof img === "string" ? { url: img } : { url: img.url });
            });
          }
          setRoom({ ...matchedRoom, images: imagesArray });
        }
      }
    });

    return () => unsubscribe();
  }, [seater, type]);

  if (!room) return <p className="text-center mt-20 text-gray-500">Loading...</p>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-3xl font-bold">{room.name} — {room.type}</h2>
        <button
          onClick={() => navigate("/booking")}
          className="bg-pink-600 text-white px-6 py-2 rounded-xl font-semibold hover:bg-pink-500 transition"
        >
          Book Now
        </button>
      </div>

      {room.images.length === 0 ? (
        <p className="text-gray-500">No images uploaded yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {room.images.map((img, idx) => (
            <img
              key={idx}
              src={img.url}
              alt={`${room.name} ${idx + 1}`}
              className="w-full h-64 object-cover rounded-lg shadow-md"
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default RoomSeaterPage;
